import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  GlobalStyle,
  Container,
  Header,
  Logo,
  Nav,
  NavLinks,
  MobileMenuContainer,
  HamburgerButton,
  MobileMenu,
  MobileMenuLink,
  MobileLoginButton,
  LoginButton,
  Footer,
  FooterContent,
  FooterSection,
  FooterLogo,
  FooterBottom,
  SocialIcons,
  SocialIcon,
  EbookSection,
  EbookContent,
  EbookImageContainer,
  EbookTextContent,
  EbookTitle,
  EbookSubtitle,
  EbookDescription,
  EbookHighlight,
  EbookButton
} from './styled';
import logo from '../../assets/logo_navbar.png';
import ebookImage from '../../assets/img/capa_nota1000.png';
import ModalCadastro from '../../components/ModalCadastro';

function EbookPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const menuRef = React.useRef();
  const hamburgerRef = React.useRef();
  const history = useHistory();

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLoginClick = () => {
    // Redirecionar para a página de login da plataforma
    history.push('/login');
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleMobileMenu = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleClickOutside = (event) => {
    if (
      mobileMenuOpen &&
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(event.target)
    ) {
      setMobileMenuOpen(false);
    }
  };

  const handleOpenModal = () => {
    // Abrir o modal de cadastro
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
    <GlobalStyle />
    <Container>
      <ModalCadastro isOpen={modalOpen} onClose={handleCloseModal} />
      <Header>
        <Nav>
          <Logo>
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </Logo>
          <NavLinks>
             <Link to="/">Página Inicial</Link>
           </NavLinks>
          <LoginButton onClick={handleLoginClick}>Fazer Login</LoginButton>
        </Nav>
          <MobileMenuContainer>
            <HamburgerButton
              ref={hamburgerRef}
              open={mobileMenuOpen}
              onClick={toggleMobileMenu}
            >
              <span></span>
              <span></span>
              <span></span>
            </HamburgerButton>
            {mobileMenuOpen && (
              <MobileMenu isOpen={mobileMenuOpen} ref={menuRef}>
                <MobileMenuLink as={Link} to="/">Página Inicial</MobileMenuLink>
                <MobileLoginButton onClick={handleLoginClick}>Login na Plataforma</MobileLoginButton>
              </MobileMenu>
            )}
          </MobileMenuContainer>
        </Header>

        <EbookSection id="ebook" data-reveal>
          <EbookContent>
            <EbookImageContainer>
            <iframe
              src="https://www.youtube.com/embed/VyKfLBEbOoA?autoplay=1&loop=1&playlist=VyKfLBEbOoA&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3"
              title="E-book da Clara - YouTube Shorts"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                width: '100%',
                maxWidth: '394px',
                height: '700px',
                borderRadius: '20px',
                boxShadow: '0 20px 50px rgba(0, 0, 0, 0.15)',
                transition: 'all 0.3s ease'
              }}
            />
          </EbookImageContainer>
            <EbookTextContent>
              <EbookTitle>E-book da Clara</EbookTitle>
              <EbookSubtitle>O segredo por trás da nota 1000 no ENEM 2024</EbookSubtitle>
              <EbookDescription>
                Descubra os métodos e estratégias que levaram Clara da Barra de Oliveira a conquistar a nota máxima na redação do ENEM 2024, sendo uma entre apenas 12 candidatos a alcançar esse feito extraordinário.
              </EbookDescription>
              <EbookHighlight>
                Estratégias exclusivas da aluna nota 1000
              </EbookHighlight>
              <EbookDescription>
                Neste e-book exclusivo, você terá acesso aos insights, técnicas de escrita e dicas práticas que fizeram a diferença na jornada da Clara rumo à excelência na redação do ENEM.
              </EbookDescription>
              <EbookButton onClick={handleOpenModal}>
                Comprar Agora
              </EbookButton>
            </EbookTextContent>
          </EbookContent>
        </EbookSection>

        <Footer id="contato">
          <FooterContent>
            <FooterSection>
              <FooterLogo>
                <img src={logo} alt="Logo" />
              </FooterLogo>
              
              <div className="NewsletterForm">
                {/* <input type="email" placeholder="Digite seu email" />
                <button>ENVIAR</button> */}
              </div>
            </FooterSection>
            <FooterSection>
              {/* <h4>Menu Acesso Rápido</h4>
              <a href="#">Página de exemplo</a>
              <a href="#">Página de exemplo</a>
              <a href="#">Página de exemplo</a> */}
            </FooterSection>
            <FooterSection>
              <h4>Fale com a gente!</h4>
              <p>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.488"/>
                </svg>
                (21) 96957-0209
              </p>
              <p>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22S19,14.25 19,9A7,7 0 0,0 12,2Z"/>
                </svg>
                Rua Gavião Peixoto, 124, sala 509 - Edifício Manhattan
              </p>
              
              <p>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.11,4 20,4Z"/>
                </svg>
                cursodaniellevelasco@gmail.com
              </p>
            </FooterSection>
          </FooterContent>
          <FooterBottom>
            <p>&copy; copyright {new Date().getFullYear()} Curso Danielle Velasco</p>
            <SocialIcons>
              <SocialIcon href="https://open.spotify.com/show/6OahTLB012BVlm26zUcMvn" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.84-.179-.84-.6 0-.359.24-.66.54-.78 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.242 1.021zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.youtube.com/@cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.tiktok.com/@cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.instagram.com/cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://wa.me/5521969570209" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.facebook.com/cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </SocialIcon>
            </SocialIcons>
          </FooterBottom>
        </Footer>
      </Container>
    </>
  );
}

export default EbookPage;